import { ImageType } from '@shared/product/models';

export const currentPage = 0;

export enum PageProductsLoad {
    GRID_16 = 48,
    GRID_4 = 20,
    ZARA_STUDIO = 10,
}

export interface CustomCategoryGrid {
    gridCustomCategory: GridDefault;
    totalQuantityProducts: number;
    categoryId: string;
}

export interface GridElement {
    template: string;
    ccIds: number[];
    hiddenFieldsByProduct: Array<{ name: string; productId: string[] }>;
    style: GridProductStyle;
}

export interface GridDefault {
    totalPagesIds: number; // Total de paginas a visualizar
    idsFiltered: number[]; // Total de Ids a mostrar en la grid
    pageProductIds: number[]; // Paginación de Productos, se irá rellenando con scroll
    currentPage: number;
    productsFullyLoaded?: boolean;
}

export interface GridProductStyle {
    tintColor: string; backgroundColor: string;
}

export interface RecentlyProductViewed {
    arraySku: number[];
    colorId: string;
    mocaId: string;
    product_id: string;
    timestamp: number;
    uid: string;
}

export interface RelatedProductsCustomGridConfig {
    showPromoProducts: boolean;
    productsSet: number;
    productsImage: ImageType;
    campaign: string;
    categoriesConfig: Record<string, { excluded: { subFamilyIds: string[] } }>;
}
